import { IDocumentDetailField } from 'common/document/interfaces/document-detail-field';
import { IVerificationResultByRecognition } from 'common/ui/interfaces/verification-result-by-recognition';
import {
  VerificationResultByRecognition,
  VerificationResultByRecognitionExpirationPassed,
} from '../../../../common/ui/constants/verification-result-by-recognition';
import { DocumentDetailFieldStatusEnum } from 'common/document/enums/document-detail-field-status.enum';

export type IFieldVerificationResult = {
  [key: string]: IVerificationResultByRecognition;
};

export const buildVerificationResult = (
  inputData: IDocumentDetailField[] | null | undefined
): IFieldVerificationResult | undefined => {
  if (!inputData?.length || !Object.keys(inputData).length) {
    return undefined;
  }
  return Object.values(inputData).reduce(
    (hash: { [key: string]: any }, currentValue: any) => {
      let text =
        currentValue?.verificationResult ||
        VerificationResultByRecognition.text;
      let title = VerificationResultByRecognition.title;

      if (
        currentValue?.verificationStatus ===
        DocumentDetailFieldStatusEnum.EXPIRED
      ) {
        text =
          currentValue?.verificationResult ||
          VerificationResultByRecognitionExpirationPassed.text;
        title = VerificationResultByRecognitionExpirationPassed.title;
      }

      hash[currentValue.fieldName] = {
        title,
        text,
      };
      return hash;
    },
    {}
  );
};
